import React from 'react';
import { DownloadIcon, FolderIcon, TrashIcon } from 'react-line-awesome';
import { useStyletron } from 'baseui';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'baseui/modal';
import { Button, ButtonRow } from '@gtintel/platform-atoms';
import { generateZip } from '@gtintel/platform-utils';
import { getAllAttachmentChildren } from './utils';
const Folder = ({
  node,
  projectName,
  openFolder,
  removeAttachment
}) => {
  const [css] = useStyletron();
  const [showModal, setShowModal] = React.useState(false);
  const [isDeleting, setIsDeleting] = React.useState(false);
  const downloadFolder = evt => {
    evt.stopPropagation();
    generateZip(getAllAttachmentChildren(node), projectName);
  };
  const showDeleteModal = evt => {
    evt.stopPropagation();
    setShowModal(true);
  };
  const deleteAllAttachments = async () => {
    setIsDeleting(true);
    const files = getAllAttachmentChildren(node);
    for (const file of files) {
      await removeAttachment(file.id, 'document');
    }
    setIsDeleting(false);
    setShowModal(false);
  };
  return <React.Fragment>
      <div data-testid={`folder-${node.name}`} className={css({
      alignItems: 'center',
      border: '1px solid transparent',
      borderRadius: '4px',
      cursor: 'pointer',
      display: 'flex',
      flexFlow: 'column',
      justifyContent: 'space-between',
      padding: '28px',
      position: 'relative',
      ':hover': {
        borderColor: '#e1e1e1'
      },
      '.la-folder': {
        fontSize: '24px',
        marginBottom: '8px'
      }
    })} tabIndex={0} onClick={() => openFolder(node)} onKeyPress={event => {
      if (event.key === 'Enter') openFolder(node);
    }} role="button">
        <div className={css({
        display: 'flex',
        flexFlow: 'row nowrap',
        gap: '4px',
        justifyContent: 'flex-end',
        position: 'absolute',
        top: '8px',
        right: '8px',
        width: 'calc(100% - 16px)',
        zIndex: 1
      })}>
          {removeAttachment && <Button size="mini" kind="secondary" onClick={showDeleteModal} testId="delete-folder-button">
              <TrashIcon />
            </Button>}
          <Button size="mini" kind="secondary" onClick={downloadFolder} testId="download-folder-button">
            <DownloadIcon />
          </Button>
        </div>

        <FolderIcon />
        <span>{node.name}</span>
      </div>

      <Modal isOpen={showModal} onClose={() => setShowModal(false)} animate autoFocus size="xlarge" overrides={{
      Root: {
        style: {
          zIndex: 2
        }
      }
    }}>
        <ModalHeader>Delete Folder</ModalHeader>
        <ModalBody>
          <p>Are you sure you want to delete the folder "{node.name}"</p>

          <p>It contains these files:</p>

          <ul>
            {getAllAttachmentChildren(node).map(attachment => <li key={attachment.id}>
                {attachment.internal_path}/{attachment.filename}
              </li>)}
          </ul>
        </ModalBody>
        <ModalFooter>
          <ButtonRow flexPosition="flex-end">
            <Button kind="secondary" onClick={() => setShowModal(false)}>
              Close
            </Button>
            <Button kind="error" loading={isDeleting} disabled={isDeleting} onClick={deleteAllAttachments} testId="confirm-delete-folder-button">
              Delete
            </Button>
          </ButtonRow>
        </ModalFooter>
      </Modal>
    </React.Fragment>;
};
export default Folder;